(() => {
  function incrementCartCount(quantity) {
    const counters = Array.from(document.querySelectorAll('xo-cart-size, .nni-cart-size'));
    const currentCount = counters.reduce((count, counter) => {
      const value = Number.parseInt(counter.innerText, 10);
      return Number.isFinite(value) ? Math.max(count, value) : count;
    }, 0);
    const itemCount = currentCount + quantity;

    const applyCount = () => {
      counters.forEach((counter) => {
        if (counter.matches('xo-cart-size')) {
          const replacement = document.createElement('span');
          replacement.className = 'nni-cart-size';
          replacement.innerText = String(itemCount);
          counter.replaceWith(replacement);
        } else {
          counter.innerText = String(itemCount);
        }
      });
    };

    applyCount();
    [250, 750, 1500].forEach((delay) => window.setTimeout(applyCount, delay));

  }

  const NCR_PIN_PATTERN = /^(110|121|122|201)\d{3}$/;
  const PLATTER_HANDLES = ['sattu-soul-platter', 'litti-bites-platter', 'mumbai-magic-platter', 'nis-platter', 'kids-platter', 'mithila-chaat-kachori', 'hi-protein-chaat-kachori'];
  let pendingPlatterVariant = null;
  let pendingNcrAction = 'add';

  function ensureNcrDialog() {
    let dialog = document.getElementById('nni-ncr-dialog');
    if (dialog) return dialog;
    document.body.insertAdjacentHTML('beforeend', `<dialog id="nni-ncr-dialog" class="nni-ncr-dialog" aria-labelledby="nni-ncr-title">
      <button class="nni-ncr-dialog__close" type="button" data-ncr-close aria-label="Close">×</button>
      <p class="nni-kicker">Delhi NCR delivery</p><h2 id="nni-ncr-title">Check your delivery PIN</h2>
      <p>Platters are freshly prepared and delivered only within Delhi, Gurgaon, Noida, Ghaziabad and Faridabad.</p>
      <label for="nni-ncr-pincode">6-digit PIN code</label>
      <input id="nni-ncr-pincode" type="text" inputmode="numeric" autocomplete="postal-code" maxlength="6" pattern="[0-9]{6}" placeholder="e.g. 110001">
      <p class="nni-ncr-dialog__error" data-ncr-error role="alert" hidden>Sorry, platter delivery is available only in Delhi, Gurgaon, Noida, Ghaziabad and Faridabad.</p>
      <button class="nni-btn nni-btn--orange" type="button" data-ncr-confirm>Check &amp; add to cart</button>
    </dialog>`);
    return document.getElementById('nni-ncr-dialog');
  }

  function ncrDialog() {
    return ensureNcrDialog();
  }

  function openNcrDialog(variantId, action = 'add') {
    pendingPlatterVariant = variantId;
    pendingNcrAction = action;
    const dialog = ncrDialog();
    if (!dialog) return;
    const error = dialog.querySelector('[data-ncr-error]');
    const confirm = dialog.querySelector('[data-ncr-confirm]');
    if (error) error.hidden = true;
    if (confirm) confirm.textContent = action === 'checkout' ? 'Confirm PIN & checkout' : 'Check & add to cart';
    dialog.showModal();
    window.setTimeout(() => dialog.querySelector('#nni-ncr-pincode')?.focus(), 50);
  }

  async function refreshNcrCartState() {
    try {
      const cart = await fetch('/cart.js').then((response) => response.json());
      const hasPlatter = cart.items.some((item) => PLATTER_HANDLES.includes(item.handle));
      document.documentElement.dataset.nniHasPlatter = String(hasPlatter);
      document.documentElement.dataset.nniNcrPin = cart.attributes?.ncr_delivery_pincode || '';
    } catch (error) {
      document.documentElement.dataset.nniHasPlatter = 'false';
    }
  }

  async function addNcrPlatter(pin) {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{
        id: Number(pendingPlatterVariant),
        quantity: 1,
        properties: { '_ncr_only': 'true', 'Delivery PIN': pin }
      }] })
    });
    if (!response.ok) throw new Error('Unable to add platter');
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { ncr_delivery_pincode: pin } })
    });
    document.documentElement.dataset.nniHasPlatter = 'true';
    document.documentElement.dataset.nniNcrPin = pin;
    incrementCartCount(1);
  }

  function init() {
    if (document.documentElement.dataset.nniReady) return;
    document.documentElement.dataset.nniReady = '1';
    refreshNcrCartState();

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('form[action*="/cart/add"]');
      const handle = location.pathname.split('/products/')[1]?.split('/')[0];
      if (!form || !PLATTER_HANDLES.includes(handle)) return;
      event.preventDefault();
      const variantId = new FormData(form).get('id');
      openNcrDialog(variantId, 'add');
    }, true);

    document.querySelectorAll('.nni-tabs button').forEach((button) => {
      button.addEventListener('click', () => {
        button.closest('.nni-tabs').querySelectorAll('button').forEach((item) => item.classList.remove('is-active'));
        button.classList.add('is-active');

        const filter = button.dataset.filter || 'all';
        document.querySelectorAll('.nni-product-card').forEach((card) => {
          const title = card.dataset.productTitle || '';
          const matches = filter === 'all' || (filter === 'sattu' ? title.includes('sattu') || title.includes('litti') : title.includes(filter));
          card.hidden = !matches;
        });
      });
    });

    document.addEventListener('click', async (event) => {
      const checkoutControl = event.target.closest('[name="checkout"], a[href*="/checkout"]');
      if (checkoutControl && document.documentElement.dataset.nniHasPlatter === 'true' && !NCR_PIN_PATTERN.test(document.documentElement.dataset.nniNcrPin || '')) {
        event.preventDefault();
        openNcrDialog(null, 'checkout');
        return;
      }

      const platterButton = event.target.closest('[data-platter-add]');
      if (platterButton) {
        openNcrDialog(platterButton.dataset.variantId);
        return;
      }

      if (event.target.closest('[data-ncr-close]')) {
        ncrDialog()?.close();
        return;
      }

      const ncrConfirm = event.target.closest('[data-ncr-confirm]');
      if (ncrConfirm) {
        const dialog = ncrDialog();
        const input = dialog?.querySelector('#nni-ncr-pincode');
        const error = dialog?.querySelector('[data-ncr-error]');
        const pin = (input?.value || '').replace(/\D/g, '');
        if (!NCR_PIN_PATTERN.test(pin)) {
          if (error) error.hidden = false;
          input?.focus();
          return;
        }
        ncrConfirm.disabled = true;
        ncrConfirm.textContent = pendingNcrAction === 'checkout' ? 'Opening checkout…' : 'Adding…';
        try {
          if (pendingNcrAction === 'checkout') {
            await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attributes: { ncr_delivery_pincode: pin } }) });
            document.documentElement.dataset.nniNcrPin = pin;
            location.href = '/checkout';
          } else {
            await addNcrPlatter(pin);
            ncrConfirm.textContent = 'Added to cart';
            window.setTimeout(() => dialog?.close(), 650);
          }
        } catch (error) {
          ncrConfirm.textContent = 'Try again';
        } finally {
          ncrConfirm.disabled = false;
        }
        return;
      }

      const variantButton = event.target.closest('[data-variant-select]');
      if (variantButton) {
        const card = variantButton.closest('.nni-product-card');
        card.querySelectorAll('[data-variant-select]').forEach((item) => item.classList.toggle('is-active', item === variantButton));
        card.querySelector('.nni-buy-row').dataset.variantId = variantButton.dataset.variantId;
        const price = card.querySelector('[data-product-price]');
        if (price) price.textContent = variantButton.dataset.variantPrice;
        return;
      }

      const opener = event.target.closest('[data-quick-view-open]');
      if (opener) { document.getElementById(opener.dataset.quickViewOpen)?.showModal(); return; }
      const closer = event.target.closest('[data-quick-view-close]');
      if (closer) { closer.closest('dialog')?.close(); return; }
      if (event.target.matches('.nni-quick-view')) {
        const rect = event.target.getBoundingClientRect();
        const inside = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
        if (!inside) event.target.close();
        return;
      }

      const row = event.target.closest('.nni-buy-row');
      if (!row) return;

      const quantityInput = row.querySelector('input');
      const quantity = () => Math.max(1, Number(quantityInput.value) || 1);

      if (event.target.matches('[data-qty-minus]')) quantityInput.value = Math.max(1, quantity() - 1);
      if (event.target.matches('[data-qty-plus]')) quantityInput.value = quantity() + 1;

      if (event.target.matches('[data-add-cart]')) {
        const button = event.target;
        button.disabled = true;
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(row.dataset.variantId), quantity: quantity() }] })
          });
          if (!response.ok) throw new Error('Unable to add item');
          incrementCartCount(quantity());
          button.textContent = 'Added';
        } catch (error) {
          button.textContent = 'Try again';
        } finally {
          button.disabled = false;
        }
      }

      if (event.target.matches('[data-buy-now]')) {
        location.href = `/cart/${row.dataset.variantId}:${quantity()}?checkout`;
      }
    });

    const track = document.querySelector('.nni-values__track');
    if (track && matchMedia('(max-width: 749px)').matches && track.children.length > 2) {
      let index = 0;
      const timer = setInterval(() => {
        if (document.hidden) return;
        index = (index + 2) % track.children.length;
        const card = track.children[index];
        track.scrollTo({ left: Math.max(0, card.offsetLeft - track.offsetLeft), behavior: 'smooth' });
      }, 3500);

      const pause = () => {
        clearInterval(timer);
        track.removeEventListener('touchstart', pause);
        track.removeEventListener('pointerdown', pause);
      };
      track.addEventListener('touchstart', pause, { passive: true });
      track.addEventListener('pointerdown', pause);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
